import { useState } from "react";
import { message } from "antd";

import { useUpsertTraineeMeasurement } from "~/modules/Trainee/TraineeProfile/TraineeFeatures/TraineeMeasurements/useTraineeMeasurementsQueries";
import { type WeightMeasurementFormModel } from "./types";

export const useWeightMeasurementForm = (traineeId: string) => {
  const [showWeightModal, toggleWeightModal] = useState(false);
  const upsertMeasurement = useUpsertTraineeMeasurement(traineeId);

  const onAddNewWeightMeasurement = async (formModel: WeightMeasurementFormModel) => {
    try {
      await upsertMeasurement.mutateAsync({
        data: {
          weight: formModel.weight,
        },
        eventDate: formModel.date.format("YYYY-MM-DD"),
        id: formModel.id,
        previousMeasurement: formModel.previousMeasurement,
      });
      toggleWeightModal(false);
    } catch {
      // Modal zostaje otwarty, żeby nie stracić wpisanych wartości.
      void message.error("Nie udało się zapisać pomiaru. Spróbuj ponownie.");
    }
  };

  return {
    showWeightModal,
    toggleWeightModal,
    addingWeightMeasurement: upsertMeasurement.isLoading,
    onAddNewWeightMeasurement,
  };
};
